import React, { Fragment, useState, useEffect } from "react";
import { Image, Button, Col, Row, Form, Modal, Table } from "react-bootstrap";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { TextField, FormControl, Select } from "@material-ui/core";
import { amApi } from "../../../../../../api/apiHelper";
import SlidingComponent from "../../../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import SuperAdminCall from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import SuperAdminSMS from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import SuperAdminNotification from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification";
import SuperAdminBlockUser from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminBlockUser";
import SuperAdminFlag from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminFlag";
import { SuperAdminVendorViewDetailsPopup } from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminVendorViewDetailsPopup";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import axios from "axios";
import { serverApi, webappUrl } from "../../../../../../config/Keys";
import { useDispatch, useSelector } from "react-redux";
import Alert from "react-s-alert";
import ResetPasswordPopup from "../../../../../reusableComponents/resetPasswordPopup/ResetPasswordPopup";
import AdminTwilioCallingPopup from "../../../superAdminPendingVendors/AdminTwilioCallingPopup";
import SuperAdminChatWindowPopup from "../../../superAdminPendingVendors/SuperAdminChatWindowPopup";
import QRCodeMerchants from "../../../../../reusableComponents/QRCodePrintAndExport/QRCodeMerchants";
import {
  create_and_update_restaurant,
  get_new_subscription_for_vendor,
} from "../../../../../../store/actions/authAction";
import { setVendorAccess } from "../../../../../../store/actions/vendorAccessActions";
import { statuses } from "../../../../../reusableComponents/BusinessTimingsStatus";
import { errorAlert, successAlert } from "../../../../../../function/alert";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};
// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     transform: "translate(-50%, -50%)",
//     position: "relative",
//   },
// };

// const onHoldReason = [
//   { id: 1, name: "Profile Not Completed", value: "Profile Not Completed" },
//   { id: 2, name: "Others", value: "Others" },
// ];

export const AllVendorTableBody = (props) => {
  const [TrDetail, setTrDetail] = useState(false);
  let history = useHistory();
  const [stats, setStats] = useState({});
  const [pointOfContact, setPointOfContact] = useState();
  const authUser = useSelector((state) => state.auth.user);
  const [statusData, setStatusData] = useState({
    friends: props.vendorData.friends,
    userDetails: props.vendorData.userDetails,
    campaign: props.vendorData.campaign,
    delivery: (props?.vendorData?.ordering?.home_delivery?.value && props?.vendorData?.subscription?.delivery_partner == 2) ? true : false,
    softOnboarding: props?.vendorData?.softOnboarding ? false : true,
    payLaterService: props?.vendorData?.payLaterService,
  });
  useEffect(() => {
    setPointOfContact(props.vendorData.point_of_contact);
    props.setDataWhole(props.sendData);
  }, []);

  useEffect(() => {
    setStatusData({
      friends: props.vendorData.friends,
      userDetails: props.vendorData.userDetails,
      campaign: props.vendorData.campaign,
      softOnboarding: props?.vendorData?.softOnboarding ? false : true,
      payLaterService: props?.vendorData?.payLaterService,
      delivery: (props?.vendorData?.ordering?.home_delivery?.value && props?.vendorData?.subscription?.delivery_partner == 2) ? true : false,
    });
  }, [
    props.vendorData?.friends,
    props.vendorData?.userDetails,
    props.vendorData?.campaign,
    props.vendorData?.softOnboarding,
    props.vendorData?.payLaterService,
  ]);

  const showTr = async () => {
    if (TrDetail === true) {
      let statData = await axios.get(
        `${serverApi}/admin/restaurant/${props.vendorData._id}`,
        {
          headers: {
            Authorization: authUser.accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      setStats(statData.data);
    }
    setTrDetail(!TrDetail);
  };

  let filtereddata = {};
  filtereddata =
    pointOfContact &&
    pointOfContact.filter((vendor) => vendor.defaultChecked === true);

  const [showShareMail, setShowShareMail] = useState(false);

  const dispatch = useDispatch();
  const onViewDashboard = () => {
    history.push("/customerbusiness");
  };

  const vendorDashboard = (id) => () => {
    dispatch(create_and_update_restaurant({ vendor_id: id }));
    dispatch(get_new_subscription_for_vendor({ vendor_id: id }));
    dispatch(setVendorAccess(id, onViewDashboard));
  };

  const monData = props?.vendorData?.monday?.multipleHours;
  const tueData = props?.vendorData?.tuesday?.multipleHours;
  const wedData = props?.vendorData?.wednesday?.multipleHours;
  const thuData = props?.vendorData?.thursday?.multipleHours;
  const friData = props?.vendorData?.friday?.multipleHours;
  const satData = props?.vendorData?.saturday?.multipleHours;
  const sunData = props?.vendorData?.sunday?.multipleHours;

  const onFriends = async () => {
    try {
      if (
        !statusData.friends === false &&
        (statusData?.campaign || statusData?.userDetails)
      ) {
        errorAlert("Switch off Campaign/User Details");
        return;
      }
      let data = await amApi.patch(
        `/admin/restaurant/${props.vendorData._id}`,
        { friends: !statusData.friends, restaurant: true }
      );
      if (data.status === 200) {
        successAlert("Updated Successfully");
      }
      setStatusData({ ...statusData, friends: !statusData.friends });
    } catch (err) {
      errorAlert(
        err?.response?.data?.message || "Something went wrong, try later"
      );
    }
  };

  const onCampaign = async () => {
    try {
      let data = await amApi.patch(
        `/admin/restaurant/${props.vendorData._id}`,
        { campaign: !statusData.campaign, restaurant: true }
      );
      if (data.status === 200) {
        successAlert("Updated Successfully");
      }
      setStatusData({ ...statusData, campaign: !statusData.campaign });
    } catch (err) {
      errorAlert(
        err?.response?.data?.message || "Something went wrong, try later"
      );
    }
  };

  const onUserDetails = async () => {
    try {
      let data = await amApi.patch(
        `/admin/restaurant/${props.vendorData._id}`,
        { userDetails: !statusData.userDetails, restaurant: true }
      );
      if (data.status === 200) {
        successAlert("Updated Successfully");
      }
      setStatusData({ ...statusData, userDetails: !statusData.userDetails });
    } catch (err) {
      errorAlert(
        err?.response?.data?.message || "Something went wrong, try later"
      );
    }
  };

  const onChangeDelivery = async () => {
    try {
      let data = await amApi.put(
        `/admin/subscription/${props.vendorData?.subscription?._id}`,
        { delivery_partner: statusData.delivery ? 1 : 2}
      );
      if (data.status === 200) {
        successAlert("Updated Successfully");
      }
      setStatusData({ ...statusData, delivery: !statusData.delivery });
    } catch (err) {
      errorAlert(
        err?.response?.data?.message || "Something went wrong, try later"
      );
    }
  };

  const onEnableOrderingServices = async () => {
    if (props?.vendorData?.page_completed_till < 21) {
      errorAlert("Please fill out the bank kyc account information");
    } else if (props?.vendorData?.scanPay?.addedAccounts?.length === 0) {
      errorAlert("Please fill out the Scan and Pay account information");
    } else if (
      props?.vendorData?.ordering?.maintain_separate_bank?.addedAccounts
        ?.length === 0
    ) {
      errorAlert(
        "Please fill out the maintain separate bank account information"
      );
    } else {
      try {
        let data = await amApi.patch(
          `/admin/restaurant/${props.vendorData._id}`,
          {
            softOnboarding: !props?.vendorData?.softOnboarding,
            restaurant: true,
          }
        );
        if (data.status === 200) {
          successAlert("Updated Successfully");
          setStatusData({
            ...statusData,
            softOnboarding: !statusData?.softOnboarding ? true : false,
          });
        }
      } catch (err) {
        errorAlert(
          err?.response?.data?.message || "Something went wrong, try later"
        );
      }
    }
  };

  const onEnablePayLaterServices = async () => {
    if (props?.vendorData?.ordering?.value !== true) {
      errorAlert("Please Enable Ordering services");
    } else {
      try {
        let data = await amApi.patch(
          `/admin/restaurant/${props.vendorData._id}`,
          {
            payLaterService: !props?.vendorData?.payLaterService,
            restaurant: true,
          }
        );
        if (data.status === 200) {
          successAlert("Updated Successfully");
          setStatusData({
            ...statusData,
            payLaterService: !statusData?.payLaterService,
          });
        }
      } catch (err) {
        errorAlert(
          err?.response?.data?.message || "Something went wrong, try later"
        );
      }
    }
  };

  return (
    <Fragment>
      <tbody className="w-100 super-admin-all-vendor-main-table-body">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  style={{
                    border: "none",
                    borderRadius: "5px 0px 0px 5px",
                    borderLeft:
                      props?.statusOnline !== "" &&
                      statuses[props?.statusOnline]?.hexCode
                        ? `1.0708vw solid ${
                            statuses[props?.statusOnline]?.hexCode
                          }`
                        : "0vw solid transparent",
                  }}
                  className="sd_body_table-row p-0"
                  onClick={showTr}
                >
                  <td
                    style={{ width: "2%" }}
                    className="table-body-left-vertical-badge-td"
                  >
                    {props?.statusOnline !== "" &&
                    statuses[props?.statusOnline]?.hexCode ? (
                      <div className="f9-500" style={{ letterSpacing: 1 }}>
                        {statuses[props?.statusOnline]?.title?.toUpperCase()}
                      </div>
                    ) : null}
                  </td>
                  <td
                    style={{
                      width:
                        props?.statusOnline !== "" &&
                        statuses[props?.statusOnline]?.hexCode
                          ? "10%"
                          : "12%",
                    }}
                  >
                    <div className="vendor-main-section-one">
                      <div className="image-box">
                        <div className="Image-box-section">
                          <Image
                            fluid
                            alt="Restaurant Photo"
                            title="Restaurant Photo"
                            src={props.vendorData.logo_url}
                          />
                          {/* <div className="inside-image-box-discout">
                            <Image
                              fluid
                              alt="Discount Picture"
                              title="Discount Picture"
                              src={require("../../../../../../assets/images/superadmin/discount.svg")}
                            />
                          </div> */}
                        </div>
                        <div>
                          <h5 className="font_16_m mt-2">
                            #
                            {props.vendorData._id.substr(
                              props.vendorData._id.length - 15
                            )}
                          </h5>
                        </div>
                      </div>
                      <div className="start-rating-review-box mt-2">
                        <Image
                          fluid
                          alt="wait time"
                          title="wait time"
                          className="star-image-box mr-1"
                          src={require("../../../../../../assets/images/superadmin/star.svg")}
                        />
                        <h5 className="font_16_m d-flex align-items-center">
                          {props.vendorData.averageRating}
                          <span className="w-100 font_10_r ml-1">
                            ({props.vendorData.totalReviews} reviews)
                          </span>
                        </h5>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "14%" }}>
                    <h3 className="font_20_m">
                      {props.vendorData.restaurant_name}
                    </h3>
                  </td>
                  <td style={{ width: "16%", wordBreak: "break-word" }}>
                    {!isEmpty(filtereddata) &&
                      filtereddata.map((singleitem, index) => {
                        return (
                          <React.Fragment key={index}>
                            <div className="font_18_m d-flex">
                              {singleitem.firstName + " " + singleitem.lastName}
                            </div>
                            {/* <p className="font_12_m">
                              ({singleitem.selected_position})
                            </p> */}
                            {!isEmpty(singleitem.enquiry_emails) &&
                              singleitem.enquiry_emails.map((email, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <div
                                      className="font_18_m mb-2 mt-2 text-lowercase"
                                      style={{ wordBreak: "break-word" }}
                                    >
                                      {email}
                                    </div>
                                  </React.Fragment>
                                );
                              })}
                            {!isEmpty(singleitem.phone_numbers) &&
                              singleitem.phone_numbers.map((phone, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <div className="font_18_m">
                                      {phone.country_code +
                                        " " +
                                        phone.mobile_no}
                                    </div>
                                  </React.Fragment>
                                );
                              })}
                          </React.Fragment>
                        );
                      })}
                  </td>
                  <td style={{ width: "6%", wordBreak: "break-word" }}>
                    <div className="font_18_r">{props.vendorData.city}</div>
                  </td>
                  <td style={{ width: "6%", wordBreak: "break-word" }}>
                    <div className="font_18_r mb-2">
                      {props.vendorData.area}
                    </div>
                    <div className="font_18_r">{props.vendorData.pinCode}</div>
                  </td>
                  <td style={{ width: "6%", wordBreak: "break-word" }}>
                    <div className="font_18_r">
                      {props.vendorData.vendor.referral_code}
                    </div>
                  </td>
                  {/* <td style={{ width: "18%" }}>
                     <div className="font_18_r mb-2">
                      {props.vendorData.area}
                    </div>
                    <div className="font_18_r">{props.vendorData.city}</div>
                    <div className="font_18_r">{props.vendorData.pinCode}</div>
                    <div className="font_18_r">
                      {props.vendorData.vendor.referral_code}
                    </div> 
                    <div className="font_18_r">
                      {props.vendorData.restaurant_address}
                    </div>
                  </td> */}
                  <td style={{ width: "10%", textAlign: "center" }}>
                    <div className="progressCircleTbl">
                      <CircularProgressbar
                        value={Math.round(
                          (props.vendorData.page_completed_till / 21) * 100
                        )}
                        text={`${Math.round(
                          (props.vendorData.page_completed_till / 21) * 100
                        )}%`}
                        styles={buildStyles({
                          pathColor: `#FEC32D`,
                          textColor: "gray",
                          trailColor: "#d6d6d6",
                          backgroundColor: "#3e98c7",
                        })}
                      />
                    </div>
                    <div className="font_18_m mt-3">
                      {props.vendorData.softOnboarding ? "Soft Onboarded" : ""}
                    </div>
                  </td>
                  <td style={{ width: "12%" }}>
                    <div className="font_18_b">
                      {props.vendorData.primary_restaurant_type.length !== 0
                        ? props.vendorData.primary_restaurant_type[0].title
                        : ""}
                    </div>
                    <div className="font_18_r">
                      {props.vendorData.primary_cusine.length !== 0
                        ? props.vendorData.primary_cusine[0].title
                        : ""}
                    </div>
                    <div className="w-75">
                      <hr />
                      <div className="font_18_r">
                        {/* <img
                          className="organic-image"
                          src={
                            props.vendorData.primary_food_type.length !== 0
                              ? props.vendorData.primary_food_type[0].icon
                              : require("./../../../../../../assets/images/superadmin/marilend.png")
                          }
                          alt="type"
                        /> */}
                        {props.vendorData.restaurant_chain_id.length !== 0
                          ? props.vendorData.restaurant_chain_id[0].title
                          : ""}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "7%" }}>
                    {/* {!isEmpty(props.vendorData.vendor) &&
                      props.vendorData.vendor.map((value, index) => {
                        return (
                          <React.Fragment key={index}> */}
                    <p className="font_18_m p-12">
                      {props.vendorData &&
                      props.vendorData.vendor.has_admin_approved
                        ? "Active"
                        : "In Active"}
                    </p>
                    <SlidingComponent
                      name="has_admin_approved"
                      currentState={
                        props.vendorData &&
                        props.vendorData.vendor.has_admin_approved
                      }
                      type={"checkbox"}
                      toggleclass={
                        "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                      }
                      toggleinputclass={
                        "toggle__switch vendor-super-admin-toggle"
                      }
                      onChange={props.toggleFunction}
                      defaultChecked={
                        props.vendorData &&
                        props.vendorData.vendor.has_admin_approved === true
                          ? true
                          : false
                      }
                    />
                    {/* </React.Fragment>
                        );
                      })} */}
                  </td>
                  <td style={{ width: "11%" }}>
                    <div
                      className="p-2 f10-700 cursor"
                      style={{
                        border: "1px solid #EE3A23",
                        borderRadius: "5px",
                      }}
                      onClick={vendorDashboard(props.vendorData.vendor._id)}
                    >
                      View Dashboard
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-end mb-2">
                      <Button
                        variant="link"
                        className="enIconBtn p-2" //action_icon_padding
                        onClick={props.adminSeatingDashboard}
                      >
                        <Image
                          src={require("../../../../../../assets/images/ActionImages/image/onboarding.svg")}
                          alt="onboarding"
                          title="onboarding"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn ml-2 p-2"
                        onClick={props.ratingReviewActionId}
                      >
                        <Image
                          src={require("../../../../../../assets/images/ActionImages/image/rating.svg")}
                          alt="Rating"
                          title="Rating"
                          fluid
                        />
                      </Button>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <Button
                        variant="link"
                        className="enIconBtn p-2"
                        onClick={props.handleShowEdit}
                      >
                        <Image
                          src={require("../../../../../../assets/images/ActionImages/image/order.svg")}
                          alt="order"
                          title="order"
                          fluid
                        />
                      </Button>
                      <NavLink to="/superadmineventmanagement">
                        <Button
                          variant="link"
                          className="enIconBtn ml-2 p-2"
                          onClick={props.handleShowEdit}
                        >
                          <Image
                            src={require("../../../../../../assets/images/ActionImages/image/events.svg")}
                            alt="events"
                            title="events"
                            fluid
                          />
                        </Button>
                      </NavLink>
                    </div> */}
                  </td>
                </tr>
                {TrDetail && (
                  <>
                    <tr className="sd_accordion_body">
                      <td style={{ width: "20%" }}>
                        <h5 className="font_18_b mb-3">Contact</h5>
                        <div className="d-flex align-items-center">
                          {/* <SuperAdminCall /> */}
                          <AdminTwilioCallingModal
                            sendData={props.vendorData.point_of_contact}
                          />
                          <SuperAdminChatWindowPopup
                            data={props.vendorData}
                            text={"seating"}
                          />
                          {/* <Button
                            variant="link"
                            className="enIconBtn mr-3 action_icon_padding"
                            onClick={props.handleShowFlag}
                          >
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/chat.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button> */}
                          <SuperAdminSMS dataSend={props.vendorData} />
                          <SuperAdminNotification dataSend={props.vendorData} />
                        </div>
                      </td>
                      <td style={{ width: "14%" }}>
                        <div className="font_18_b mb-4">
                          No. of Seating Request
                        </div>
                        <h5 className="font_18_r">
                          {!isEmpty(stats)
                            ? stats.No_seating_request
                            : props.vendorData.No_seating_request}
                        </h5>
                      </td>
                      <td style={{ width: "12%" }}>
                        <div className="font_18_b mb-4">No. of Orders</div>
                        <h5 className="font_18_r">
                          {!isEmpty(stats)
                            ? stats.No_ordering_request
                            : props.vendorData.No_ordering_request}
                        </h5>
                      </td>
                      <td style={{ width: "12%" }}>
                        <div className="font_18_b mb-4">No. of Offers</div>
                        <h5 className="font_18_r">
                          {!isEmpty(stats)
                            ? stats.No_offers
                            : props.vendorData.No_offers}
                        </h5>
                      </td>
                      <td style={{ width: "12%" }}>
                        <div className="font_18_b mb-4">No. of Events</div>
                        <h5 className="font_18_r">
                          {!isEmpty(stats)
                            ? stats.No_events
                            : props.vendorData.No_events}
                        </h5>
                      </td>
                      <td style={{ width: "30%" }}>
                        <h5 className="font_18_b c_red mb-3">More Actions</h5>
                        <div className="d-flex align-items-center">
                          {/* <NavLink to="/superadminvendorsprofileview"></NavLink> */}
                          <button
                            className="enIconBtn mr-3 action_icon_padding bg-transparent"
                            onClick={props.handleProfileClick}
                            type="button"
                          >
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/profile.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </button>
                          <SuperAdminFlag
                            data={props.vendorData}
                            actionCall={"active"}
                          />
                          <SuperAdminBlockUser
                            data={props.vendorData}
                            actionCall={"active"}
                          />
                          <SuperAdminVendorViewDetailsPopup
                            viewData={props.vendorData}
                          />
                          <ResetPasswordPopup data={props.vendorData} />
                          <button
                            className="enIconBtn mr-3 action_icon_padding bg-transparent"
                            // onClick={props.handleProfileClick}
                            onClick={props.onClickEditButton}
                            type="button"
                          >
                            <i className="fa fa-pencil text-gray"></i>
                          </button>
                          {/* <SuperAdminBlockUser data={props.vendorData} /> */}
                        </div>
                      </td>
                    </tr>
                    <hr style={{ width: "95%" }} />
                    <tr className="sd_accordion_row">
                      <td style={{ width: "13%" }}>
                        <h5 className="font_18_b mb-3">Revenue</h5>
                        <div className="d-flex align-items-center">
                          <h5 className="font_18_r">
                            {props.vendorData.revenue}
                          </h5>
                        </div>
                      </td>
                      <td style={{ width: "13%" }}>
                        <div className="font_18_b mb-4">Hours of Operation</div>
                        {props?.vendorData?.are_you_open_24_x_7 ? (
                          <div className="f11-500">Open 24*7</div>
                        ) : (
                          <div className="f11-500">
                            Closes:{" "}
                            {moment().format("dddd") === "Sunday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  sunData && sunData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  sunData && sunData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Monday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  monData && monData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  monData && monData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Tuesday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  tueData && tueData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  tueData && tueData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Wednesday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  wedData && wedData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  wedData && wedData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Thursday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  thuData && thuData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  thuData && thuData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Friday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  friData && friData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  friData && friData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Saturday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  satData && satData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  satData && satData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                          </div>
                        )}
                        {/* <h5 className="font_18_r">
                          Closes: {moment().format("HH : mm A")}
                        </h5> */}
                        <div className="d-flex align-items-center mt-1">
                          <img
                            src={require("../../../../../../assets/images/ActionImages/image/waitlist.svg")}
                            alt="Walkin Waitlist"
                            title="Walkin Waitlist"
                            className="img-fluid mr-2"
                            style={{ width: "9%" }}
                          />
                          <h5 className="font_18_r mr-2">
                            {props.vendorData.seatingWaitingTime}
                          </h5>
                          <h5 className="font_18_m c_red">
                            {props.vendorData.seatingWaitingTime === "00-00"
                              ? ""
                              : "Wait"}
                          </h5>
                        </div>
                      </td>
                      <td style={{ width: "20%" }}>
                        <div className="font_18_b mb-4">Address</div>
                        <h5 className="font_18_r">
                          {props.vendorData.restaurant_address}
                        </h5>
                      </td>
                      <td style={{ width: "13%" }}>
                        <div className="font_18_b mb-4">POS System</div>
                        {props.vendorData.primaryPointOfSale.length &&
                          props.vendorData.primaryPointOfSale.map((pos, i) => (
                            <h5
                              className="font_18_r"
                              style={{ padding: "0px 2px" }}
                              key={i}
                            >
                              {pos.title}
                            </h5>
                          ))}
                      </td>
                      <td style={{ width: "17%" }}>
                        <div className="font_18_b mb-4">Services Offered</div>
                        {props.vendorData.primary_services_offered.length &&
                          props.vendorData.primary_services_offered.map(
                            (service, i) => (
                              <h5
                                className="font_18_r"
                                style={{ padding: "0px 2px" }}
                                key={i}
                              >
                                {service.title}
                              </h5>
                            )
                          )}
                      </td>
                      <td style={{ width: "13%" }}>
                        <h5 className="font_18_b mb-4">Located Inside</h5>
                        {props.vendorData.selected_located_inside.length &&
                          props.vendorData.selected_located_inside.map(
                            (service) => (
                              <h5
                                className="font_18_r"
                                style={{ padding: "0px 2px" }}
                              >
                                {service.title}
                              </h5>
                            )
                          )}
                      </td>
                      <td style={{ width: "13%" }}>
                        <div className="font_18_b mb-4">Liquor</div>
                        {props.vendorData.selected_liquor_category.length &&
                          props.vendorData.selected_liquor_category.map(
                            (service, i) => (
                              <h5
                                className="font_18_r"
                                style={{ padding: "0px 2px" }}
                                key={i}
                              >
                                {service.title}
                              </h5>
                            )
                          )}
                      </td>
                    </tr>
                    <hr style={{ width: "95%" }} />
                    <tr className="sd_accordion_row">
                      <td style={{ width: "15%" }}>
                        <h5 className="font_18_b mb-3">Cuisines</h5>
                        <div className="d-flex align-items-center">
                          {props.vendorData.primary_cusine.length &&
                            props.vendorData.primary_cusine.map((cusine, i) => (
                              <h5
                                className="font_18_r"
                                style={{ padding: "0px 2px" }}
                                key={i}
                              >
                                {cusine.title}
                              </h5>
                            ))}
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="font_18_b mb-4">Subscription</div>
                        {props?.vendorData?.are_you_open_24_x_7 ? (
                          <div className="f11-500">Open 24*7</div>
                        ) : (
                          <div className="f11-500">
                            Closes:{" "}
                            {moment().format("dddd") === "Sunday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  sunData && sunData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  sunData && sunData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Monday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  monData && monData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  monData && monData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Tuesday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  tueData && tueData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  tueData && tueData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Wednesday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  wedData && wedData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  wedData && wedData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Thursday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  thuData && thuData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  thuData && thuData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Friday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  friData && friData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  friData && friData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Saturday" ? (
                              <React.Fragment>
                                {/* {moment(
                                  satData && satData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp; */}
                                {moment(
                                  satData && satData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                          </div>
                        )}
                        {/* <h5 className="font_18_r">
                          Closes: {moment().format("HH : mm A")}
                        </h5> */}
                        <div className="d-flex align-items-center mt-1">
                          <img
                            src={require("../../../../../../assets/images/ActionImages/image/waitlist.svg")}
                            alt="Walkin Waitlist"
                            title="Walkin Waitlist"
                            className="img-fluid mr-2"
                            style={{ width: "9%" }}
                          />
                          <h5 className="font_18_r mr-2">
                            {props.vendorData.seatingWaitingTime}
                          </h5>
                          <h5 className="font_18_m c_red">
                            {props.vendorData.seatingWaitingTime === "00-00"
                              ? ""
                              : "Wait"}
                          </h5>
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="font_18_b mb-4">Member Since</div>
                        <h5 className="font_18_r">
                          {moment(props.vendorData.createdAt).format(
                            "DD/MM/YYYY"
                          )}
                        </h5>
                      </td>
                      <td style={{ width: "20%" }}></td>
                      <td style={{ width: "25%" }}>
                        <div className="font_18_b mb-4">Share Credentials</div>
                        <button
                          className="onboarding_button_link_reusable onboarding_button_link_reusable_red_outlined mt-2"
                          type="button"
                          onClick={(e) => setShowShareMail(true)}
                        >
                          Share
                        </button>
                      </td>
                      <td style={{ width: "30%" }}>
                        <div className="font_18_b mb-4"> QR code Setup</div>
                        <QRCodeMerchants
                          door_front={{
                            restaurantId: props.vendorData._id,
                            // restaurant_name: props.vendorData.restaurant_name,
                            // restaurant_address:
                            //   props.vendorData.restaurant_address,
                            // type: "door_front",
                            // vendor_id: props.vendorData?.vendor_id,
                          }}
                          restaurantData={props.vendorData}
                          restaurantId={props.vendorData._id}
                          webappUrl={`${webappUrl}/restaurant/${props.vendorData._id}`}
                          referral_data={
                            props?.vendorData?.vendor?.shareLink
                              ?.userShortLink || ""
                          }
                          table_management_data={
                            {
                              ...props.vendorData?.casual_dining
                                ?.table_management?.table_setup,
                              type: "table_management",
                              vendor_id: props.vendorData?.vendor_id,
                              restaurant_id: props.vendorData._id,
                            } || {
                              ...props.vendorData?.fast_food_dining
                                ?.table_management?.table_setup,
                              type: "table_management",
                              vendor_id: props.vendorData?.vendor_id,
                              restaurant_id: props.vendorData._id,
                            } || {
                              ...props.vendorData?.multi_service_business
                                ?.table_management?.table_setup,
                              type: "table_management",
                              vendor_id: props.vendorData?.vendor_id,
                              restaurant_id: props.vendorData._id,
                            }
                          }
                          table_management_status={
                            props.vendorData?.casual_dining?.table_management
                              ?.value ||
                            props.vendorData?.fast_food_dining?.table_management
                              ?.value ||
                            props.vendorData?.multi_service_business
                              ?.table_management?.value
                          }
                          restaurantLogo={props?.vendorData?.logo_url}
                          restaurantName={props?.vendorData?.restaurant_name}
                        />
                      </td>
                    </tr>
                    <hr style={{ width: "95%" }} />
                    <tr className="sd_accordion_row">
                      <td style={{ width: "13%" }}>
                        <p className="font_18_m p-12">Friends of Amealio</p>
                        <SlidingComponent
                          name="friends"
                          currentState={statusData.friends}
                          type={"checkbox"}
                          checked={statusData.friends}
                          toggleclass={
                            "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                          }
                          toggleinputclass={
                            "toggle__switch vendor-super-admin-toggle"
                          }
                          onChange={onFriends}
                          defaultChecked={
                            statusData.friends === true ? true : false
                          }
                        />
                      </td>
                      <td style={{ width: "12%" }}>
                        <p className="font_18_m p-12">User Details Display</p>
                        <SlidingComponent
                          name="userDetails"
                          currentState={statusData.userDetails}
                          checked={statusData.userDetails}
                          type={"checkbox"}
                          toggleclass={
                            "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                          }
                          toggleinputclass={
                            "toggle__switch vendor-super-admin-toggle"
                          }
                          onChange={onUserDetails}
                          defaultChecked={
                            statusData.userDetails === true ? true : false
                          }
                        />
                      </td>
                      <td style={{ width: "10%" }}>
                        <p className="font_18_m p-12">Campaign Promo</p>
                        <SlidingComponent
                          name="campaign"
                          currentState={statusData.campaign}
                          type={"checkbox"}
                          checked={statusData.campaign}
                          toggleclass={
                            "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                          }
                          toggleinputclass={
                            "toggle__switch vendor-super-admin-toggle"
                          }
                          onChange={onCampaign}
                          defaultChecked={
                            statusData.campaign === true ? true : false
                          }
                        />
                      </td>
                      <td style={{ width: "10%" }}>
                        <p className="font_18_m p-12">Dunzo delivery</p>
                        <SlidingComponent
                          name="delivery"
                          currentState={statusData.delivery}
                          type={"checkbox"}
                          checked={statusData.delivery}
                          toggleclass={
                            "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                          }
                          toggleinputclass={
                            "toggle__switch vendor-super-admin-toggle"
                          }
                          onChange={onChangeDelivery}
                          defaultChecked={
                            statusData.delivery === true ? true : false
                          }
                        />
                      </td>
                      <td style={{ width: "10%" }}>
                        <p className="font_18_m p-12">
                          Enable Ordering & other services
                        </p>
                        <SlidingComponent
                          name="softOnboarding"
                          currentState={statusData.softOnboarding}
                          type={"checkbox"}
                          checked={statusData.softOnboarding}
                          toggleclass={
                            "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                          }
                          toggleinputclass={
                            "toggle__switch vendor-super-admin-toggle"
                          }
                          onChange={onEnableOrderingServices}
                          defaultChecked={
                            statusData.softOnboarding === true ? true : false
                          }
                        />
                      </td>
                      <td style={{ width: "10%" }}>
                        <p className="font_18_m p-12">
                          Enable Pay later services
                        </p>
                        <SlidingComponent
                          name="payLaterService"
                          currentState={statusData.payLaterService}
                          type={"checkbox"}
                          checked={statusData.payLaterService}
                          toggleclass={
                            "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                          }
                          toggleinputclass={
                            "toggle__switch vendor-super-admin-toggle"
                          }
                          onChange={onEnablePayLaterServices}
                          defaultChecked={
                            statusData.payLaterService ? true : false
                          }
                        />
                      </td>
                      <td style={{ width: "10%", textAlign: "center" }}>
                        <p className="font_18_m p-12">Daily Clicks</p>
                        <p className="font_18_m p-12">
                          {props?.vendorData?.dailyViews || 0}
                        </p>
                      </td>
                      <td style={{ width: "10%", textAlign: "center" }}>
                        <p className="font_18_m p-12">Weekly Clicks</p>
                        <p className="font_18_m p-12">
                          {props?.vendorData?.weeklyViews || 0}
                        </p>
                      </td>
                      <td style={{ width: "10%", textAlign: "center" }}>
                        <p className="font_18_m p-12">Total Clicks</p>
                        <p className="font_18_m p-12">
                          {props?.vendorData?.overAllViews || 0}
                        </p>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      {showShareMail && (
        <ShareWelcomeEmail
          vendor={props.vendorData.vendor}
          hideCancel={() => setShowShareMail(false)}
        />
      )}
    </Fragment>
  );
};

export const AdminTwilioCallingModal = (props) => {
  const [callingModal, setCallingModal] = useState(false);
  const onOpenModal = () => {
    setCallingModal(true);
  };
  const onCloseModal = () => {
    setCallingModal(false);
  };

  return (
    <React.Fragment>
      <Button variant="link" className="enIconBtn mr-3" onClick={onOpenModal}>
        <Image
          src={require("../../../../../../assets/images/UserManagement/phone.svg")}
          alt="Call"
          title="Call"
          fluid
        />
      </Button>
      <Modal
        show={callingModal}
        onHide={onCloseModal}
        backdrop="static"
        keyboard={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>User Contact List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 p-0 user-table-reusable-superadmin">
            <Table className="HideShowTable">
              <thead>
                <tr className="super_admin_all_users_table_head">
                  <th style={{ width: "7.5%" }} className="f12-700">
                    SR No.
                  </th>
                  <th style={{ width: "12.5%" }} className="f12-700">
                    Profile Photo
                  </th>
                  <th style={{ width: "11.5%" }} className="f12-700">
                    First Name
                  </th>
                  <th style={{ width: "11.5%" }} className="f12-700">
                    Last Name
                  </th>
                  <th style={{ width: "20.5%" }} className="f12-700">
                    Email
                  </th>
                  <th style={{ width: "18%" }} className="f12-700">
                    Number
                  </th>
                  <th style={{ width: "18.5%" }} className="f12-700">
                    Position
                  </th>
                </tr>
              </thead>
              {!isEmpty(props.sendData) &&
                props?.sendData.map((data, index) => {
                  return (
                    <tbody
                      style={{
                        lineBreak: "anywhere",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "10px",
                        boxShadow: "0px 3px 6px #00000014",
                        padding: "10px 0px",
                      }}
                      key={index}
                    >
                      <tr>
                        <td style={{ width: "7.5%" }} className="f10-400">
                          {++index}
                        </td>
                        <td style={{ width: "12.5%" }} className="f10-400">
                          <SimpleReactLightbox>
                            <SRLWrapper options={options}>
                              <Image
                                src={data.photo_thumbnails}
                                className="img-fluid rounded w-50"
                                alt="User"
                                title="User"
                              />
                            </SRLWrapper>
                          </SimpleReactLightbox>
                        </td>
                        <td style={{ width: "11.5%" }} className="f10-400">
                          {data.firstName}
                        </td>
                        <td style={{ width: "11.5%" }} className="f10-400">
                          {data.lastName}
                        </td>
                        <td style={{ width: "20.5%" }} className="f10-400">
                          {!isEmpty(data.enquiry_emails) &&
                            data?.enquiry_emails.map((data, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <p className="mb-2">{data}</p>
                                </React.Fragment>
                              );
                            })}
                        </td>
                        <td style={{ width: "18%" }} className="f10-400">
                          {!isEmpty(data.phone_numbers) &&
                            data?.phone_numbers.map((number, index) => {
                              return (
                                <div
                                  className="mb-3 d-flex align-items-center w-100"
                                  key={index}
                                >
                                  <p className="mr-3">
                                    {number.country_code + number.mobile_no}
                                  </p>
                                  <AdminTwilioCallingPopup
                                    allData={data}
                                    sendData={number}
                                  />
                                </div>
                              );
                            })}
                        </td>
                        <td style={{ width: "18.5%" }} className="f10-400">
                          {data.selected_position}
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onCloseModal}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

const ShareWelcomeEmail = (props) => {
  const [login, setLogin] = useState(
    `${props.vendor?.mobile_number} / ${props.vendor?.email}`
  );
  const [password, setPassword] = useState("");
  const [mail, setMail] = useState("");
  const [name, setName] = useState("");
  const [ccMail, setCcMail] = useState("");

  const [confirm, setConfirm] = useState(false);

  const submitShare = async () => {
    // props.submitExternal(ref);
    if (login && password && mail && name) {
      let data = {
        email: login,
        password: password,
        mail: mail,
        id: props.vendor?._id,
        name: name,
        ccMail: ccMail,
      };
      let res = await amApi.post("/admin/welcomeVendor", data);
      if (res.status === 201) {
        setLogin("");
        setPassword("");
        setMail("");
        setName("");
        setCcMail("");
        setConfirm(false);
        Alert.success(`<h4>Email Sent Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        Alert.error(`<h4>Try again Later</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } else {
      Alert.error(`<h4>Please Enter all the details</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  return (
    <React.Fragment>
      <Modal show={true} onHide={props.hideCancel} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f18-700">Enter Credentials Details</div>
        </Modal.Header>
        <Modal.Body>
          <div className="f18-500 mt-2 mb-4">
            <Form.Group>
              <TextField
                id="name"
                variant="outlined"
                label="Name"
                name="name"
                className={`w-100`}
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </Form.Group>
            <Form.Group>
              <TextField
                id="email"
                variant="outlined"
                label="To Mail"
                name="mail"
                className={`w-100`}
                onChange={(e) => setCcMail(e.target.value)}
                value={ccMail}
              />
            </Form.Group>
            <Form.Group>
              <TextField
                id="loginId"
                variant="outlined"
                label="Login Id"
                name="loginId"
                className={`w-100`}
                onChange={(e) => setLogin(e.target.value)}
                value={login}
              />
            </Form.Group>
            <Form.Group>
              <TextField
                id="password"
                variant="outlined"
                label="Password"
                name="password"
                className={`w-100`}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
            </Form.Group>
            <Form.Group>
              <TextField
                id="sentMail"
                variant="outlined"
                label="Sent From Mail"
                name="sentMail"
                className={`w-100`}
                onChange={(e) => setMail(e.target.value)}
                value={mail}
              />
            </Form.Group>
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-6">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  onClick={props.hideCancel}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={() => setConfirm(true)}
                >
                  Done
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {confirm && (
        <ShareWelcomeDetails
          data={{
            login: login,
            name: name,
            password: password,
            ccMail: ccMail,
            mail: mail,
          }}
          hideCancel={(e) => setConfirm(false)}
          handleConfirm={submitShare}
        />
      )}
    </React.Fragment>
  );
};

const ShareWelcomeDetails = (props) => {
  return (
    <React.Fragment>
      <Modal show={true} onHide={props.hideCancel} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f18-700">Confirm Credentials Details</div>
        </Modal.Header>
        <Modal.Body>
          <div className="f18-500 mt-2 mb-4">Name : {props.data.name}</div>
          <div className="f18-500 mt-2 mb-4">
            Add On Mail : {props.data.ccMail}
          </div>
          <div className="f18-500 mt-2 mb-4">Login ID : {props.data.login}</div>
          <div className="f18-500 mt-2 mb-4">
            Password : {props.data.password}
          </div>
          <div className="f18-500 mt-2 mb-4">From Mail : {props.data.mail}</div>
          <div className="mt-4">
            <div className="row">
              <div className="col-6">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  onClick={props.hideCancel}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={props.handleConfirm}
                >
                  Confirm
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
